import { AnyAction, Dispatch, ThunkDispatch } from '@reduxjs/toolkit';
import { FirebaseError } from 'firebase/app';
import {
  signInWithEmailAndPassword,
  User,
  setPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
  ActionCodeOperation,
} from 'firebase/auth';

import { auth } from '../../../config/firebase-config';
import { AppUser } from '../../reducers/User/types';
import { IAppState } from '../../types';
import { ActionTypes } from './types';

export const setUser = (user: User) => (dispatch: Dispatch<AnyAction>) => {
  const appUser: AppUser = {
    displayName: user.displayName ?? undefined,
    email: user.email ?? undefined,
    emailVerified: user.emailVerified,
    phoneNumber: user.phoneNumber ?? undefined,
    photoUrl: user.photoURL ?? undefined,
    uid: user.uid,
  };

  dispatch({
    type: ActionTypes.DO_LOGIN,
    payload: {
      user: appUser,
    },
  });
};

export const doLogin = (
  loginEmail: string,
  loginPassword: string,
  remember: boolean,
) => async (dispatch: ThunkDispatch<IAppState, void, AnyAction>): Promise<string> => {
  try {
    await setPersistence(auth, remember ? browserLocalPersistence : browserSessionPersistence)
      .then(async () => {
        const { user } = await signInWithEmailAndPassword(auth, loginEmail, loginPassword);
        dispatch(setUser(user));
      })
      .catch((error: FirebaseError) => {
        throw error;
      });
    return ActionCodeOperation.EMAIL_SIGNIN;
  } catch (error: any) {
    return error.code;
  }
};

export const doLogout = async (dispatch: Dispatch<AnyAction>): Promise<void> => {
  dispatch({ type: ActionTypes.DO_LOGOUT });
};
